import React from 'react'
import { Badge } from 'reactstrap'
import { NetSuiteAsset, NetSuiteAssetProduct } from 'types'
import ProductGrid from '../ProductGrid'
import UnassignedLicenseGrid from '../UnassignedLicensesGrid'
import LicenseGrid from '../LicenseGrid'

interface ContractLineSectionsProps {
  products: NetSuiteAssetProduct[]
  unassignedAssets: NetSuiteAsset[]
  assignedAssets: NetSuiteAsset[]
  onSetupLicense: (asset: NetSuiteAsset) => void
  onEditLicense: (asset: NetSuiteAsset) => void
}

const ContractLineSections: React.FC<ContractLineSectionsProps> = ({
  products,
  unassignedAssets,
  assignedAssets,
  onSetupLicense,
  onEditLicense,
}) => {
  return (
    <>
      <fieldset>
        <legend>Products</legend>
        <ProductGrid products={products} />
      </fieldset>

      <fieldset>
        <legend>
          Unassigned Licenses&nbsp;
          <Badge color="info">{unassignedAssets.length}</Badge>
        </legend>
        <UnassignedLicenseGrid
          assets={unassignedAssets}
          onSetupLicense={onSetupLicense}
        />
      </fieldset>

      <fieldset>
        <legend>
          Assigned Licenses&nbsp;
          <Badge color="info">{assignedAssets.length}</Badge>
        </legend>
        <LicenseGrid licenses={assignedAssets} onEditLicense={onEditLicense} />
      </fieldset>
    </>
  )
}

export default ContractLineSections
